import { Routes } from '@angular/router';
import { AccountComponent } from './features/account/account.component';
import { authGuard } from './core/auth/auth.guard';
import { registrationProgressGuard } from './core/guards/registration-progress.guard';
import { isSubscriberGuard } from './core/guards/is-subscriber.guard';

export enum AppPath {
  Auth = 'auth',
  Account = 'account',
}

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing/landing.component'),
  },
  {
    path: AppPath.Auth,
    loadComponent: () => import('./features/auth/auth.layout'),
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: AppPath.Account,
    component: AccountComponent,
    loadChildren: () =>
      import('./features/account/account.routes').then((m) => m.routes),
    canMatch: [
      authGuard({ needsAuthentication: true, redirectTo: ['/'] }),
      registrationProgressGuard(),
      isSubscriberGuard(),
    ],
  },
];
